import { render, staticRenderFns } from "./SamGuide.vue?vue&type=template&id=d06b6d62&scoped=true&shadow"
import script from "./SamGuide.vue?vue&type=script&lang=js&shadow"
export * from "./SamGuide.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "d06b6d62",
  null
  ,true
)

export default component.exports